import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'

import styles from './Content.module.scss'

export const Content = ({ questions }) => {
  const total = questions?.length ?? Number.NaN

  return (
    <Box className={styles.content} tagName="article">
      <List direction="column">
        {questions.map(({ description, id, title }, index) => {
          const count = index + 1

          return (
            <List.Item key={id}>
              <span className={styles.count}>{t`${count} of ${total}`}</span>
              <h3 className={styles.title}>{title}</h3>
              {(description?.length ?? Number.NaN) > 0 ? (
                <Box className={styles.container} direction="column">
                  <p className={styles.description}>{description}</p>
                </Box>
              ) : null}
            </List.Item>
          )
        })}
      </List>
    </Box>
  )
}
